import React from 'react';
import PropTypes from 'prop-types';
import {FmlxIcon, FmlxTooltip} from 'fmlx-common-ui';

import {useIntl} from 'react-intl';

import style from './HighCV.module.scss';

function HighCV({recommendedCapacity, taskType, customClass}) {
  const {formatMessage} = useIntl();

  return (
    <div className={`${style.container} ${customClass}`}>
      <FmlxTooltip title={formatMessage({id: `protocolEditor.highCV.info${taskType}`}, {recommendedCapacity})}>
        <span>
          <FmlxIcon name="InfoOutline" size="xs" customColor="white" />
        </span>
      </FmlxTooltip>
      <p className={style.title}>{formatMessage({id: 'protocolEditor.highCV.title'})}</p>
    </div>
  );
}

export default HighCV;

HighCV.propTypes = {
  // minCapacity: PropTypes.number,
  recommendedCapacity: PropTypes.number,
  taskType: PropTypes.string,
  customClass: PropTypes.string,
};

HighCV.defaultProps = {
  // minCapacity: 0.5,
  recommendedCapacity: 3,
  taskType: '',
  customClass: '',
};
